const person = () => import('./person');

const h5weRouter = [
  {
    path: '/h5we/person',
    name: 'h5wePerson',
    component: person,
    meta: {
      c: 'h5we', a: 'person', noLayout: true, noAuth: true
    }
  },
];

export default h5weRouter;
